import { useState } from "react";
import { ImageOff } from "lucide-react";
import { cn } from "../lib/cn";

export interface ImagePreviewProps {
  src: string | null;
  alt?: string;
  className?: string;
}

/**
 * Renders the rendered draft PNG in a 4:5 portrait frame. Falls back to a
 * placeholder when the image is missing or fails to load (e.g. not yet rendered).
 */
export function ImagePreview({ src, alt = "Draft image", className }: ImagePreviewProps) {
  const [failed, setFailed] = useState(false);

  const showImage = src && !failed;

  return (
    <div
      className={cn(
        "relative aspect-[4/5] w-full overflow-hidden rounded-lg border border-slate-200 bg-slate-100",
        className,
      )}
    >
      {showImage ? (
        <img
          src={src}
          alt={alt}
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2 text-slate-400">
          <ImageOff className="h-8 w-8" />
          <span className="text-xs">No image yet</span>
        </div>
      )}
    </div>
  );
}
